// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--hMER9","logo_link":"index-module--logo_link--3Yqb0","logo":"index-module--logo--2Dq6w"};